import { render, staticRenderFns } from "./regTypeFieldForm.vue?vue&type=template&id=3ebb7405"
import script from "./regTypeFieldForm.vue?vue&type=script&lang=js"
export * from "./regTypeFieldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports